import { Route, Routes } from 'react-router-dom'

import AgenciesOverview from './screens/AgenciesOverview'
import BrandSettings from './screens/BrandSettings'
import CustomFields from './screens/CustomFields'
import Details from './screens/Details'
import ImageSettings from './screens/ImageSettings'
import Relations from './screens/Relations'

interface BrandEditRoutesProps {
  brandId: number,
}

const BrandEditRoutes = (props: BrandEditRoutesProps) => {
  const { brandId } = props

  return (
    <Routes>
      <Route index element={<Details brandId={brandId} />} />
      <Route path="/relations" element={<Relations brandId={brandId} />} />
      <Route path="/imageSettings" element={<ImageSettings brandId={brandId} />} />
      <Route path="/customFields" element={<CustomFields brandId={brandId} />} />
      <Route path="/agenciesOverview" element={<AgenciesOverview brandId={brandId} />} />
      <Route path="/settings" element={<BrandSettings brandId={brandId} />} />
    </Routes>
  )
}

export default BrandEditRoutes
